import React from "react";
import Button from '@mui/material/Button';
import useLabRequestHook from "./labRequestHook";
import { userColumns } from "./labTestColumns";
import { DataGrid } from "@mui/x-data-grid";

const LabRequest = () => {
    const { departmentState, testNamesState, selectedRows,handleChange, handleRowClick } = useLabRequestHook();
    return (
        <div className="lab-request">
            <div className="mt-2 ml-4">
                <h4>Lab  Request</h4>
            </div>
            <div className="d-flex">
                <div className="form-group col-md-5 mt-4">
                    <label for="lname" className="control-label col-sm">Select Department</label>
                    <div class="col-auto">
                        <div class="input-group mb-2">
                            <select
                                // onBlur={handleBlur}
                                className={"form-control"}
                                // selected={selectIpd}
                                // value={selectIpd}
                                onChange={(e) => handleChange(e)}
                                required
                                name="gender"
                            >
                                <option placeholder="Select Department" disabled selected hidden>Select Department</option>
                                {
                                    departmentState?.length > 0 && departmentState?.map((ele) => (
                                        <option value={ele?.departmentID}>{ele?.departmentName}</option>
                                    ))
                                }

                            </select>
                            <div class="invalid-feedback">
                                Please provide a valid gender.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group col-md-5 mt-4">
                    <label for="lname" className="control-label col-sm">Referred By</label>
                    <div class="col-auto">
                        <div class="input-group mb-2">
                            <input
                                className="form-control"
                            />
                            <div class="invalid-feedback">
                                Please provide a valid gender.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="button-sub col-md-2 mt-4 d-flex justify-content-left align-items-center">
                    <Button
                        variant='contained'
                        color='primary'
                        className=""

                    >
                        Submit
                    </Button>
                </div>
            </div>
          {testNamesState &&  <div className="datatable">
                <DataGrid
                    onSelectionModelChange={handleRowClick}
                    checkboxSelection={true}
                    className="datagrid"
                    rows={testNamesState?.length > 0 ? testNamesState : []}
                    columns={userColumns}
                    rowsPerPageOptions={[10]}
                    getRowId={(row) => row.testID}
                    loading={false}
                    // disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={testNamesState}
                    pagination
                    pageSize={10}
                    disableColumnMenu={true}
                    selectionModel={selectedRows}

                />
            </div>}
        </div>
    );
};


export default LabRequest;